import { ErrorBoundary } from 'react-error-boundary'
import { Outlet } from 'react-router-dom'
import ErrorView from '../ErrorView'
import Header from './components/Header'
import NavigationMenu from './components/NavigationMenu'
import VersionWarningNotification from './components/VersionWarningNotification/VersionWarningNotification'
import './pagesLayout.scss'

const PagesLayout = () => (
  <div className="pages-layout">
    <VersionWarningNotification />
    <Header />
    <NavigationMenu />
    <div className="page-content">
      <ErrorBoundary
        fallbackRender={({ error, resetErrorBoundary }) => (
          <ErrorView error={error} resetErrorBoundary={resetErrorBoundary} />
        )}>
        <Outlet />
      </ErrorBoundary>
    </div>
  </div>
)

export default PagesLayout
